import { useContext, useState } from "react";
import axios from "axios";
import BASE_URL from "../constants/baseUrls";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../routing/LangRouter";
import { navigateToLoginPage } from "../utils/utility";

const useUserInfo = () => {
    //general variables
    const navigate = useNavigate();
    const location = useLocation();
    const { locale } = useContext(LocaleContext);
    const accessToken = localStorage.getItem("accessToken");
    const { t } = useTranslation();

    const [userInformation, setUserInformation] = useState(null);
    const getUserInfo = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/api/v2/account/user/info/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setUserInformation(response.data.data);
        } catch (error) {
            if (error.response.status === 401) {
                handleUnauthorizedError();
            } else {
                toast.error(t("Toast Messages.Error Occurred"), { toastId: "custom-id-yes" });
            }
        }
    };

    //handle unauthorized error (401 status)
    const handleUnauthorizedError = () => {
        localStorage.clear();
        navigateToLoginPage(navigate, locale, location);
    };

    return { userInformation, getUserInfo };
};

export default useUserInfo;
